/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DictionariesByTypeDto } from '../models';
// @ts-ignore
import type { DictionariesPageDto } from '../models';
// @ts-ignore
import type { DictionaryItemDetailedDto } from '../models';
// @ts-ignore
import type { DictionaryTypeDto } from '../models';
// @ts-ignore
import type { DictionaryTypeTranslatableDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { UpdateDictionaryRequestDto } from '../models';
/**
 * DictionariesApi - axios parameter creator
 * @export
 */
export const DictionariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get dictionaries with pagination and filters
         * @param {LanguageDto} [lang] 
         * @param {DictionaryTypeDto} [type] 
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaries: async (lang?: LanguageDto, type?: DictionaryTypeDto, name?: string, active?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dictionaries/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dictionaries by type
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionariesByType: async (lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dictionaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dictionaries by type
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionariesTypes: async (lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dictionaries/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get dictionary by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDictionaryById', 'id', id)
            const localVarPath = `/api/v1/dictionaries/by-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update dictionary
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionary: async (updateDictionaryRequestDto: UpdateDictionaryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDictionaryRequestDto' is not null or undefined
            assertParamExists('updateDictionary', 'updateDictionaryRequestDto', updateDictionaryRequestDto)
            const localVarPath = `/api/v1/dictionaries/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDictionaryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionariesApi - functional programming interface
 * @export
 */
export const DictionariesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionariesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get dictionaries with pagination and filters
         * @param {LanguageDto} [lang] 
         * @param {DictionaryTypeDto} [type] 
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaries(lang?: LanguageDto, type?: DictionaryTypeDto, name?: string, active?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionariesPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaries(lang, type, name, active, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.getDictionaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get dictionaries by type
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionariesByType(lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionariesByTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionariesByType(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.getDictionariesByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get dictionaries by type
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionariesTypes(lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DictionaryTypeTranslatableDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionariesTypes(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.getDictionariesTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get dictionary by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaryById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryItemDetailedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaryById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.getDictionaryById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update dictionary
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDictionary(updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryItemDetailedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDictionary(updateDictionaryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionariesApi.updateDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionariesApi - factory interface
 * @export
 */
export const DictionariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionariesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get dictionaries with pagination and filters
         * @param {LanguageDto} [lang] 
         * @param {DictionaryTypeDto} [type] 
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaries(lang?: LanguageDto, type?: DictionaryTypeDto, name?: string, active?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<DictionariesPageDto> {
            return localVarFp.getDictionaries(lang, type, name, active, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dictionaries by type
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionariesByType(lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionariesByTypeDto> {
            return localVarFp.getDictionariesByType(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dictionaries by type
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionariesTypes(lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryTypeTranslatableDto>> {
            return localVarFp.getDictionariesTypes(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get dictionary by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryItemDetailedDto> {
            return localVarFp.getDictionaryById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update dictionary
         * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionary(updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryItemDetailedDto> {
            return localVarFp.updateDictionary(updateDictionaryRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionariesApi - interface
 * @export
 * @interface DictionariesApi
 */
export interface DictionariesApiInterface {
    /**
     * 
     * @summary Get dictionaries with pagination and filters
     * @param {LanguageDto} [lang] 
     * @param {DictionaryTypeDto} [type] 
     * @param {string} [name] 
     * @param {boolean} [active] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    getDictionaries(lang?: LanguageDto, type?: DictionaryTypeDto, name?: string, active?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<DictionariesPageDto>;

    /**
     * 
     * @summary Get dictionaries by type
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    getDictionariesByType(lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionariesByTypeDto>;

    /**
     * 
     * @summary Get dictionaries by type
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    getDictionariesTypes(lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryTypeTranslatableDto>>;

    /**
     * 
     * @summary Get dictionary by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    getDictionaryById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryItemDetailedDto>;

    /**
     * 
     * @summary Update dictionary
     * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApiInterface
     */
    updateDictionary(updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryItemDetailedDto>;

}

/**
 * DictionariesApi - object-oriented interface
 * @export
 * @class DictionariesApi
 * @extends {BaseAPI}
 */
export class DictionariesApi extends BaseAPI implements DictionariesApiInterface {
    /**
     * 
     * @summary Get dictionaries with pagination and filters
     * @param {LanguageDto} [lang] 
     * @param {DictionaryTypeDto} [type] 
     * @param {string} [name] 
     * @param {boolean} [active] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public getDictionaries(lang?: LanguageDto, type?: DictionaryTypeDto, name?: string, active?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).getDictionaries(lang, type, name, active, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dictionaries by type
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public getDictionariesByType(lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).getDictionariesByType(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dictionaries by type
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public getDictionariesTypes(lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).getDictionariesTypes(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get dictionary by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public getDictionaryById(id: number, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).getDictionaryById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update dictionary
     * @param {UpdateDictionaryRequestDto} updateDictionaryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesApi
     */
    public updateDictionary(updateDictionaryRequestDto: UpdateDictionaryRequestDto, options?: RawAxiosRequestConfig) {
        return DictionariesApiFp(this.configuration).updateDictionary(updateDictionaryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

